import React from "react"
import ReactDOM from "react-dom"
import "./styles/index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

if (window.location.port === "3000") {
  console.log(
    "Redirecting to the dev port, please start the app with `npm run dev:web`"
  )
  window.location.href = window.location.origin.replace("3000", "8443")
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
